import { FC, ReactElement } from 'react'
import useRouter from '../../../helpers/useRouter'
import { determineRedirection, isAccessAllowed } from '../../../helpers/functions/isAccessAllowed'

type Props = {
    children: ReactElement
}

const AuthGuard: FC<Props> = ({ children }) => {
    const router = useRouter()
    if (!isAccessAllowed(router.location.pathname)) router.history.push(determineRedirection())
    return children
}

export default AuthGuard
